module.exports = __webpack_public_path__ + "static/media/crosswalk.2c6e91f2.ico";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/crosswalk.ico
// module id = 86
// module chunks = 0